/* FASS Motorsports — YMM Finder + Wheel Fitment
   assets/ymm-finder.js · paired with assets/ymm-finder.css and snippets/ymm-finder.liquid
   Config is read from data-* attributes on each .fym-finder root, so this file is
   static and cacheable. Vehicle map lives here — edit MAKES to add a make or model. */
(function () {
function initFinder(root) {
    if (!root || root.getAttribute("data-fym-ready")) return;
    root.setAttribute("data-fym-ready", "1");

    var d = root.dataset;
    var MAX_YEAR = parseInt(d.maxYear, 10) || 2026;
    var METAFIELD_PARAM = "filter.p.m.custom.compatible_years";
    var SHOW_WHEELS = d.wheels !== "false";
    var MAX_CHIPS = parseInt(d.maxChips, 10) || 8;
    var CONTACT_URL = d.contact || "/pages/contact";

    // Order makes appear in the dropdown.
    var MAKE_ORDER = ["ram", "ford", "gm", "toyota", "jeep", "nissan", "sxs", "honda"];

    // Bolt pattern -> live collection handle. Each is under Shopify's 5,000-product
    // filter cap, so custom.wheel_size filtering works inside it.
    var HANDLES = {
      "5x114.3": "5x114-3-wheels", "5x127": "5x127-wheels", "5x135": "5x135-wheels",
      "5x139.7": "5x139-7-wheels", "5x150": "5x150-wheels", "6x120": "6x120-wheels",
      "6x135": "6x135-wheels", "6x139.7": "6x139-7-wheels", "8x165.1": "8x165-1-wheels",
      "8x170": "8x170-wheels", "8x180": "8x180-wheels", "8x200": "8x200-wheels",
      "8x210": "8x210-wheels", "10x225": "10x225-wheels"
    };

    var SIZES = {
      "8x165.1": ["22x12","24x12","26x12","28x14","30x16","26x14","28x16","24x14","26x16","22x16","22x14","24x16","22x10","26x10"],
      "8x170": ["22x12","26x16","26x12","28x14","30x16","26x14","24x12","28x16","24x14","22x16","22x14","24x16","22x10","26x10"],
      "8x180": ["22x12","24x12","26x12","28x14","30x16","26x14","28x16","24x14","26x16","22x16","22x14","24x16","20x10","22x10"],
      "8x200": ["22x8.25","20x8.25","24x8.25","30x14","26x12","28x14","30x16","22x12","30x11","26x14","26x10","26x11","24x12","30x10"],
      "8x210": ["22x8.25","20x8.25","24x8.25","30x14","26x12","28x14","30x16","22x12","30x11","26x14"],
      "10x225": ["22x8.25","20x8.25","24x8.25","30x14","26x12","28x14","30x16","22x12","30x11","26x14"],
      "6x135": ["20x10","17x8.5","22x12","26x12","28x14","30x16","26x14","24x12","28x16","24x14","26x16","22x16","22x14","24x16"],
      "6x139.7": ["17x9","17x8.5","18x9","20x10","22x12","20x9","26x12","28x14","30x16","26x14","24x12","28x16","24x14","26x16"],
      "6x120": ["17x8.5","18x9","17x9","18x8","17x8","20x8.5"],
      "5x150": ["26x12","28x14","30x16","22x12","26x14","24x12","28x16","24x14","26x16","22x16","22x14","24x16","20x10","20x12"],
      "5x139.7": ["22x12","26x12","28x14","30x16","26x14","24x12","28x16","24x14","26x16","22x16","22x14","24x16","20x10","20x12"],
      "5x127": ["17x9","17x8.5","22x12","20x10","26x12","28x14","30x16","26x14","24x12","28x16","24x14","26x16","22x16","22x14"],
      "5x114.3": ["15x10","17x10","15x8","18x10","15x12","17x9","15x7","18x8","17x8","17x7","15x10.33","17x8.5","17x10.5","18x9"],
      "5x135": ["26x12","28x14","30x16","22x12","26x14","24x12","28x16","24x14","26x16","22x16","22x14","24x16","20x12","26x10"]
    };

    // make -> { label, models:[ { v, label, ranges:[ {s,e,h} ], bp:[ {s,e,p,t,n} ] } ] }
    //   ranges : parts collections.  e:null = open-ended through MAX_YEAR. h = LIVE handle.
    //   bp     : bolt patterns.      p = pattern, t = axle/trim label (optional),
    //            n = note (optional). Two bp rows matching one year render side by side.
    //   Omit bp entirely when the pattern is not on file — the pane degrades to a
    //   "shop all wheels" line rather than guessing.
    var MAKES = {
      "ram": {
        label: "RAM",
        models: [
          { v: "1500", label: "1500",
            ranges: [
              { s: 1994, e: 2001, h: "1994-2001-dodge-ram-1500" },
              { s: 2002, e: 2008, h: "2002-2008-dodge-ram-1500" },
              { s: 2009, e: 2018, h: "2009-2018-dodge-ram-1500" },
              { s: 2019, e: null, h: "2019-plus-dodge-ram-1500" }
            ],
            bp: [
              { s: 1994, e: 2018, p: "5x139.7" },
              { s: 2019, e: null, p: "6x139.7", t: "New body (DT)", n: "The DT went to 6 lugs. Not interchangeable with the Classic." },
              { s: 2019, e: 2024, p: "5x139.7", t: "Classic", n: "Sold alongside the DT through 2024 — still 5 lug." }
            ]},
          { v: "2500", label: "2500",
            ranges: [
              { s: 1981, e: 1993, h: "1981-1993-dodge-ram-2500" },
              { s: 1994, e: 2002, h: "1994-2002-dodge-ram-2500" },
              { s: 2003, e: 2009, h: "2003-2009-dodge-ram-2500" },
              { s: 2010, e: 2018, h: "2010-2018-dodge-ram-2500" },
              { s: 2019, e: null, h: "2019-plus-dodge-ram-2500" }
            ],
            bp: [ { s: 1994, e: null, p: "8x165.1" } ]},
          { v: "3500", label: "3500",
            ranges: [
              { s: 1981, e: 1993, h: "1981-1993-dodge-ram-3500" },
              { s: 1994, e: 2002, h: "1994-2002-dodge-ram-3500" },
              { s: 2003, e: 2009, h: "2003-2009-dodge-ram-3500" },
              { s: 2010, e: 2018, h: "2010-2018-dodge-ram-3500" },
              { s: 2019, e: null, h: "2019-plus-dodge-ram-3500" }
            ],
            bp: [
              { s: 1994, e: 2018, p: "8x165.1" },
              { s: 2019, e: null, p: "8x165.1", t: "Single rear wheel" },
              { s: 2019, e: null, p: "8x200", t: "Dually", n: "Dually moved to 8x200 for 2019." }
            ]},
          { v: "trx", label: "TRX",
            ranges: [ { s: 2021, e: 2024, h: "2021-dodge-ram-trx" } ],
            bp: [ { s: 2021, e: 2024, p: "6x139.7" } ]}
        ]
      },

      "ford": {
        label: "Ford",
        models: [
          { v: "f-150", label: "F-150",
            ranges: [
              { s: 1997, e: 2003, h: "1997-2003-ford-f-150" },
              { s: 2004, e: 2008, h: "2004-2008-ford-f-150" },
              { s: 2009, e: 2014, h: "2009-2014-ford-f-150" },
              { s: 2015, e: 2020, h: "2015-2020-ford-f-150" },
              { s: 2021, e: null, h: "2021-plus-ford-f-150" }
            ],
            bp: [
              { s: 1997, e: 2003, p: "5x135" },
              { s: 2004, e: null, p: "6x135" }
            ]},
          { v: "f-250", label: "F-250 Super Duty",
            ranges: [
              { s: 1980, e: 1998, h: "1980-1998-ford-f-250" },
              { s: 1999, e: 2004, h: "1999-2004-ford-f-250" },
              { s: 2005, e: 2007, h: "2005-2007-ford-f-250" },
              { s: 2008, e: 2010, h: "2008-2010-ford-f-250" },
              { s: 2011, e: 2016, h: "2011-2016-ford-f-250" },
              { s: 2017, e: 2019, h: "2017-2019-ford-f-250" },
              { s: 2020, e: 2022, h: "2020-2022-ford-f-250" },
              { s: 2023, e: null, h: "2023-ford-f-250" }
            ],
            bp: [
              { s: 1980, e: 1998, p: "8x165.1", t: "OBS" },
              { s: 1999, e: null, p: "8x170" }
            ]},
          { v: "f-350", label: "F-350 Super Duty",
            ranges: [
              { s: 1999, e: 2004, h: "1999-2004-ford-f-350" },
              { s: 2005, e: 2007, h: "2005-2007-ford-f-350" },
              { s: 2008, e: 2010, h: "2008-2010-ford-f-350" },
              { s: 2011, e: 2016, h: "2011-2016-ford-f-350" },
              { s: 2017, e: 2019, h: "2017-2019-ford-f-350" },
              { s: 2020, e: 2022, h: "2020-2022-ford-f-350" },
              { s: 2023, e: null, h: "2023-plus-ford-f-350" }
            ],
            bp: [
              { s: 1999, e: 2004, p: "8x170" },
              { s: 2005, e: null, p: "8x170", t: "Single rear wheel" },
              { s: 2005, e: null, p: "8x200", t: "Dually", n: "Dually split from the SRW truck in 2005." }
            ]},
          { v: "ranger", label: "Ranger",
            ranges: [
              { s: 1983, e: 1992, h: "1983-1992-ford-ranger" },
              { s: 1993, e: 1997, h: "1993-1997-ford-ranger" },
              { s: 1998, e: 2011, h: "1998-2010-ford-ranger" },
              { s: 2019, e: 2023, h: "2019-plus-ford-ranger" },
              { s: 2024, e: null, h: "2024-ford-ranger" }
            ],
            bp: [
              { s: 1983, e: 2011, p: "5x114.3", t: "Old body" },
              { s: 2019, e: null, p: "6x139.7", t: "Global body" }
            ]},
          { v: "raptor", label: "Raptor",
            ranges: [
              { s: 2010, e: 2014, h: "gen-1-ford-raptor" },
              { s: 2017, e: 2020, h: "ford-raptor-gen-2" },
              { s: 2021, e: null, h: "ford-raptor-gen-3" }
            ],
            bp: [ { s: 2010, e: null, p: "6x135" } ]},
          { v: "bronco", label: "Bronco",
            ranges: [
              { s: 1966, e: 1979, h: "1966-1977-ford-bronco" },
              { s: 1980, e: 1986, h: "1980-1986-ford-bronco" },
              { s: 1987, e: 1991, h: "1987-1991-ford-bronco" },
              { s: 1992, e: 1996, h: "1992-1996-ford-bronco" },
              { s: 2021, e: null, h: "2021-plus-ford-bronco" }
            ],
            bp: [
              { s: 1966, e: 1996, p: "5x139.7", t: "Full size" },
              { s: 2021, e: null, p: "6x139.7", n: "The Bronco Raptor runs 6x135 — different pattern from the standard truck." }
            ]},
          { v: "maverick", label: "Maverick",
            ranges: [ { s: 2022, e: null, h: "ford-maverick" } ]}
        ]
      },

      "gm": {
        label: "Chevy / GMC",
        models: [
          { v: "1500", label: "1500",
            ranges: [
              { s: 1999, e: 2006, h: "1999-2006-chevy-gm-1500" },
              { s: 2007, e: 2013, h: "2007-2013-gm-chevy-1500" },
              { s: 2014, e: 2018, h: "2014-2018-gm-chevy-1500" },
              { s: 2019, e: null, h: "2019-plus-chevy-gm-1500" }
            ],
            bp: [ { s: 1999, e: null, p: "6x139.7" } ]},
          { v: "2500", label: "2500",
            ranges: [
              { s: 1988, e: 2000, h: "1988-2000" },
              { s: 2001, e: 2005, h: "2001-2005-gm-chevrolet-2500" },
              { s: 2006, e: 2010, h: "2005-2010-gm-chevy-2500" },
              { s: 2011, e: 2016, h: "2011-2016-gm-chevy-2500" },
              { s: 2017, e: null, h: "2017-gm-chevy-2500" }
            ],
            bp: [
              { s: 1988, e: 2010, p: "8x165.1" },
              { s: 2011, e: null, p: "8x180" }
            ]},
          { v: "3500", label: "3500",
            ranges: [
              { s: 1988, e: 2000, h: "1988-2000-gm-chevrolet-3500" },
              { s: 2001, e: 2005, h: "2001-2005-gm-chevrolet-3500-lb7-lly" },
              { s: 2006, e: 2010, h: "2005-2010-gm-chevrolet-3500-lbz-lmm" },
              { s: 2011, e: 2016, h: "2011-2016-gm-chevrolet-3500-lml" },
              { s: 2017, e: null, h: "2017-gm-chevrolet-3500-l5p" }
            ],
            bp: [
              { s: 1988, e: 2010, p: "8x165.1" },
              { s: 2011, e: null, p: "8x180", t: "Single rear wheel" },
              { s: 2011, e: null, p: "8x210", t: "Dually" }
            ]},
          { v: "colorado", label: "Colorado",
            ranges: [
              { s: 2004, e: 2012, h: "2004-2012-chevy-colorado" },
              { s: 2015, e: 2022, h: "2015-2022-chevy-colorado" },
              { s: 2023, e: null, h: "2023-plus-chevy-colorado" }
            ],
            bp: [
              { s: 2004, e: 2012, p: "6x139.7", t: "1st gen" },
              { s: 2015, e: 2022, p: "6x120", t: "2nd gen" },
              { s: 2023, e: null, p: "6x139.7", t: "3rd gen", n: "Back to 6x5.5 for the 3rd gen." }
            ]},
          { v: "canyon", label: "Canyon",
            ranges: [
              { s: 2004, e: 2012, h: "2004-2012-gmc-canyon" },
              { s: 2015, e: 2022, h: "2015-2022-gmc-canyon" },
              { s: 2023, e: null, h: "2023-plus-gmc-canyon" }
            ],
            bp: [
              { s: 2004, e: 2012, p: "6x139.7", t: "1st gen" },
              { s: 2015, e: 2022, p: "6x120", t: "2nd gen" },
              { s: 2023, e: null, p: "6x139.7", t: "3rd gen" }
            ]}
        ]
      },

      "toyota": {
        label: "Toyota",
        models: [
          { v: "tundra", label: "Tundra",
            ranges: [ { s: 2000, e: null, h: "toyota-tundra" } ],
            bp: [
              { s: 2000, e: 2006, p: "6x139.7" },
              { s: 2007, e: 2021, p: "5x150" },
              { s: 2022, e: null, p: "6x139.7", n: "Switched back to 6 lug for 2022." }
            ]},
          { v: "tacoma", label: "Tacoma",
            ranges: [ { s: 1995, e: null, h: "toyota-tacoma" } ],
            bp: [ { s: 1995, e: null, p: "6x139.7" } ]},
          { v: "4runner", label: "4Runner",
            ranges: [ { s: 1984, e: null, h: "toyota-4runner" } ],
            bp: [ { s: 1984, e: null, p: "6x139.7" } ]},
          { v: "fj-cruiser", label: "FJ Cruiser",
            ranges: [ { s: 2007, e: 2014, h: "toyota-fj-cruiser" } ],
            bp: [ { s: 2007, e: 2014, p: "6x139.7" } ]},
          { v: "land-cruiser", label: "Land Cruiser",
            ranges: [ { s: 1963, e: null, h: "toyota-land-cruiser-series" } ],
            bp: [
              { s: 1998, e: 2021, p: "5x150" },
              { s: 2024, e: null, p: "6x139.7", t: "250 series" }
            ]},
          { v: "sequoia", label: "Sequoia",
            ranges: [ { s: 2001, e: null, h: "toyota-sequoia" } ],
            bp: [
              { s: 2001, e: 2007, p: "6x139.7" },
              { s: 2008, e: 2022, p: "5x150" },
              { s: 2023, e: null, p: "6x139.7" }
            ]}
        ]
      },

      "jeep": {
        label: "Jeep",
        models: [
          { v: "wrangler", label: "Wrangler",
            ranges: [ { s: 1987, e: null, h: "jeep-wrangler" } ],
            bp: [
              { s: 1987, e: 2006, p: "5x114.3", t: "YJ / TJ" },
              { s: 2007, e: null, p: "5x127", t: "JK / JL" }
            ]},
          { v: "gladiator", label: "Gladiator",
            ranges: [ { s: 2020, e: null, h: "jeep-gladiator" } ],
            bp: [ { s: 2020, e: null, p: "5x127" } ]},
          { v: "grand-cherokee", label: "Grand Cherokee",
            ranges: [ { s: 1993, e: null, h: "jeep-grand-cherokee" } ],
            bp: [
              { s: 1993, e: 1998, p: "5x114.3", t: "ZJ" },
              { s: 1999, e: null, p: "5x127", t: "WJ and later" }
            ]}
        ]
      },

      "nissan": {
        label: "Nissan",
        models: [
          { v: "titan", label: "Titan",
            ranges: [ { s: 2004, e: null, h: "nissan-titan" } ],
            bp: [ { s: 2004, e: null, p: "6x139.7" } ]},
          { v: "frontier", label: "Frontier",
            ranges: [ { s: 1998, e: null, h: "nissan-frontier" } ]},
          { v: "xterra", label: "Xterra",
            ranges: [ { s: 2000, e: 2015, h: "nissan-xterra" } ]}
        ]
      },

      // Defined but intentionally NOT in MAKE_ORDER (does not appear in the dropdown).
      "lexus": {
        label: "Lexus",
        models: [
          { v: "lx", label: "LX",
            ranges: [
              { s: 1998, e: 2007, h: "1998-2007-lexus-lx470" },
              { s: 2008, e: 2021, h: "2008-2021-lexus-lx570" },
              { s: 2022, e: null, h: "lexus-lx600" }
            ],
            bp: [ { s: 1998, e: null, p: "5x150" } ]},
          { v: "gx", label: "GX",
            ranges: [
              { s: 2002, e: 2009, h: "2002-2009-lexus-gx-470" },
              { s: 2010, e: 2023, h: "2023-lexus-gx460" },
              { s: 2024, e: null, h: "2024-lexus-gx-550" }
            ],
            bp: [ { s: 2002, e: null, p: "6x139.7" } ]}
        ]
      },

      "sxs": {
        label: "SXS",
        models: [
          { v: "polaris", label: "Polaris",         ranges: [ { s: 2008, e: null, h: "polaris" } ]},
          { v: "can-am",  label: "Can-Am Maverick", ranges: [ { s: 2013, e: null, h: "can-am-maverick-x3-1" } ]},
          { v: "talon",   label: "Honda Talon",     ranges: [ { s: 2019, e: null, h: "honda-talon" } ]},
          { v: "pioneer", label: "Honda Pioneer",   ranges: [ { s: 2016, e: null, h: "honda-pioneer" } ]}
        ]
      },

      "honda": {
        label: "Honda",
        models: [
          { v: "ridgeline", label: "Ridgeline", ranges: [ { s: 2006, e: null, h: "honda-ridgeline" } ]}
        ]
      }
    };

    var makeSel  = root.querySelector('[data-fym="make"]');
    var modelSel = root.querySelector('[data-fym="model"]');
    var yearSel  = root.querySelector('[data-fym="year"]');
    var goBtn    = root.querySelector('[data-fym="go"]');
    var msg      = root.querySelector('[data-fym="msg"]');
    var wheelOut = root.querySelector('[data-fym="wheel"]');
    modelSel.disabled = false; yearSel.disabled = false;

    function setMsg(t) { msg.textContent = t || ""; }
    function opt(value, text) { var o = document.createElement("option"); o.value = value; o.textContent = text; return o; }
    function esc(s) { return String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;"); }
    function clearWheels() { if (wheelOut) wheelOut.innerHTML = ""; }

    function modelsFor(make) { return (MAKES[make] && MAKES[make].models) || []; }
    function modelEntry(make, model) {
      var list = modelsFor(make);
      for (var i = 0; i < list.length; i++) if (list[i].v === model) return list[i];
      return null;
    }
    function rangesFor(make, model) { var m = modelEntry(make, model); return (m && m.ranges) || []; }
    function bpFor(make, model)     { var m = modelEntry(make, model); return (m && m.bp) || []; }

    function inRange(r, year) { return year >= r.s && year <= ((r.e === null) ? MAX_YEAR : r.e); }

    function yearsFor(make, model) {
      var set = {};
      rangesFor(make, model).forEach(function (r) {
        var top = (r.e === null) ? MAX_YEAR : r.e;
        for (var y = r.s; y <= top; y++) set[y] = true;
      });
      return Object.keys(set).map(Number).sort(function (a, b) { return b - a; });
    }
    function resolveHandle(make, model, year) {
      var ranges = rangesFor(make, model);
      for (var i = 0; i < ranges.length; i++) if (inRange(ranges[i], year)) return ranges[i].h;
      return null;
    }
    // Every bp row matching this year. More than one = SRW/DRW or body-style split.
    function resolvePatterns(make, model, year) {
      return bpFor(make, model).filter(function (r) { return inRange(r, year); });
    }

    function collUrl(pattern, size) {
      var h = HANDLES[pattern] || "wheels";
      var u = "/collections/" + h;
      if (size) u += "?filter.p.m.custom.wheel_size=" + encodeURIComponent(size);
      return u;
    }

    // Sort chips small -> large by diameter, then width. The SIZES arrays are in
    // import order, so an unsorted slice() hides every aggressive size behind "+N more".
    function sortSizes(list) {
      return list.slice().sort(function (a, b) {
        var A = String(a).split("x"), B = String(b).split("x");
        return (parseFloat(A[0]) - parseFloat(B[0])) || (parseFloat(A[1]) - parseFloat(B[1]));
      });
    }

    function buildCard(rows, vehicle) {
      var aggressive = false;
      var h = '<h3 class="fym-wheeltitle">Shop wheels for your <span>' + esc(vehicle) + '</span></h3>';
      h += '<div class="fym-card">';

      rows.forEach(function (row) {
        var sizes = sortSizes(SIZES[row.p] || []);
        h += '<div class="fym-bpgroup">';
        h += '<div class="fym-bpline"><span class="fym-bplabel">Bolt pattern</span>' +
             '<span class="fym-bp">' + esc(row.p) + '</span>';
        if (row.t) h += '<span class="fym-axle">' + esc(row.t) + '</span>';
        h += '<span class="fym-verified">Verified fitment</span></div>';
        if (row.n) h += '<p class="fym-bpnote">' + esc(row.n) + '</p>';
        h += '<a class="fym-viewall" href="' + collUrl(row.p) + '">View all ' + esc(row.p) + ' wheels &rarr;</a>';

        if (sizes.length) {
          h += '<p class="fym-sizelabel">Sizes we stock — tap to shop</p><div class="fym-chips">';
          sizes.slice(0, MAX_CHIPS).forEach(function (s) {
            h += '<a class="fym-chip" href="' + collUrl(row.p, s) + '">' + esc(s) + '</a>';
          });
          if (sizes.length > MAX_CHIPS) {
            h += '<a class="fym-chip fym-chip--more" href="' + collUrl(row.p) + '">+' +
                 (sizes.length - MAX_CHIPS) + ' more</a>';
          }
          h += '</div>';
          sizes.forEach(function (s) {
            var parts = String(s).split("x");
            if (parseFloat(parts[0]) >= 24 || parseFloat(parts[1]) >= 14) aggressive = true;
          });
        }
        h += '</div>';
      });

      h += '<div class="fym-disclaimer">' +
           '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#C79A17" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M12 9v4M12 17h.01M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z"/></svg>' +
           '<p><strong>Fitment note:</strong> Bolt pattern confirms the wheel mounts to your hub — it does not guarantee clearance. ' +
           'Custom wheel and tire sizes may require a lift or leveling kit, fender or bumper trimming, and can affect turning radius, ' +
           'speedometer accuracy, TPMS, and ride quality. Offset, backspacing, tire size, and hub bore all factor in.';
      if (aggressive) {
        h += ' Sizes above 24&quot; diameter or 14&quot; width almost always require suspension and body modification.';
      }
      h += ' Not sure? <a href="' + esc(CONTACT_URL) + '">Talk to our team</a> before you order.</p></div>';

      h += '<p class="fym-meta">' + esc(vehicle) +
           '. Always confirm fitment by counting lugs and measuring bolt-circle diameter before ordering.</p>';
      h += '</div>';

      return h;
    }

    // Mode is the top-right toggle. Parts is always the default on load and on
    // every new vehicle selection — the wheel view is opt-in, never a surprise.
    var mode = "parts";
    var PARTS_LABEL = goBtn.textContent;

    function renderWheels() {
      if (!SHOW_WHEELS || !wheelOut) return;
      var make = makeSel.value, model = modelSel.value, year = parseInt(yearSel.value, 10);
      var ready = !!(make && model && year);

      goBtn.textContent = (mode === "wheels") ? "Shop wheels that fit" : PARTS_LABEL;
      goBtn.disabled = !ready;

      if (mode !== "wheels" || !ready) { wheelOut.innerHTML = ""; return; }

      var rows = resolvePatterns(make, model, year);
      var vehicle = year + " " + MAKES[make].label + " " + modelEntry(make, model).label;

      if (!rows.length) {
        wheelOut.innerHTML =
          '<h3 class="fym-wheeltitle">Shop wheels for your <span>' + esc(vehicle) + '</span></h3>' +
          '<div class="fym-card"><p class="fym-nobp">We don\'t have a verified bolt pattern on file for the ' +
          esc(vehicle) + ' yet. <a href="/collections/wheels">Browse all wheels</a> or ' +
          '<a href="' + esc(CONTACT_URL) + '">ask our team</a> and we\'ll confirm it for you.</p></div>';
        return;
      }
      wheelOut.innerHTML = buildCard(rows, vehicle);
    }

    function setMode(next) {
      mode = next;
      root.querySelectorAll('[data-fym="mode"]').forEach(function (b) {
        var on = b.getAttribute("data-mode") === mode;
        b.classList.toggle("is-on", on);
        b.setAttribute("aria-selected", on ? "true" : "false");
      });
    }

    root.querySelectorAll('[data-fym="mode"]').forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (mode === btn.getAttribute("data-mode")) return;
        setMode(btn.getAttribute("data-mode"));
        setMsg("");
        renderWheels();
      });
    });

    function resetModel() { modelSel.innerHTML = ""; modelSel.appendChild(opt("", "Select model")); }
    function resetYear(label) { yearSel.innerHTML = ""; yearSel.appendChild(opt("", label || "Select year")); }

    MAKE_ORDER.forEach(function (k) {
      if (MAKES[k]) makeSel.appendChild(opt(k, MAKES[k].label));
    });

    makeSel.addEventListener("change", function (e) {
      if (e) e.stopPropagation();
      setMsg(""); clearWheels(); setMode("parts"); resetModel(); resetYear();
      goBtn.textContent = PARTS_LABEL; goBtn.disabled = true;
      var make = makeSel.value;
      if (!make) return;
      modelsFor(make).forEach(function (m) { modelSel.appendChild(opt(m.v, m.label)); });
    });

    modelSel.addEventListener("change", function (e) {
      if (e) e.stopPropagation();
      setMsg(""); clearWheels(); setMode("parts");
      goBtn.textContent = PARTS_LABEL; goBtn.disabled = true;
      var make = makeSel.value, model = modelSel.value;
      if (!model) { resetYear(); return; }
      resetYear();
      yearsFor(make, model).forEach(function (y) { yearSel.appendChild(opt(String(y), String(y))); });
    });

    yearSel.addEventListener("change", function (e) {
      if (e) e.stopPropagation();
      setMsg("");
      renderWheels();
    });

    goBtn.addEventListener("click", function () {
      var make = makeSel.value, model = modelSel.value, year = parseInt(yearSel.value, 10);
      if (!make || !model || !year) return;
      if (mode === "wheels") {
        var pats = resolvePatterns(make, model, year);
        setMsg("Loading wheels…");
        // One pattern goes straight to it; a SRW/DRW split has no single right answer,
        // so send them to all wheels and let the card above disambiguate.
        window.location.href = (pats.length === 1) ? collUrl(pats[0].p) : "/collections/wheels";
        return;
      }
      var handle = resolveHandle(make, model, year);
      if (!handle) { setMsg("We don't carry parts for that vehicle yet — try another year."); return; }
      setMsg("Loading your parts…");
      window.location.href = "/collections/" + handle + "?" + METAFIELD_PARAM + "=" + encodeURIComponent(year);
    });
  }

  // Idempotent. Safe to call again for finders injected after load (header modal,
  // quick-view drawers); already-wired roots carry data-fym-ready and are skipped.
  function initAll(scope) {
    (scope || document).querySelectorAll(".fym-finder").forEach(initFinder);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener("shopify:section:load", function (e) { initAll(e.target); });
  window.FASSYmm = { init: initAll };
})();